import React from "react";
import { GoogleMap } from "@react-google-maps/api";
import DirectionsServiceComponent from "./DirectionsServiceComponent";

const mapContainerStyle = {
  width: "100%",
  height: "550px",
};

const GoogleMapComponent = ({ locationsData }) => {
  const center = {
    lat: locationsData?.length > 0 ? locationsData[0].lat : 22.9971613691464,
    lng: locationsData?.length > 0 ? locationsData[0].lng : 72.49983287951699,
  };

  return (
    <GoogleMap mapContainerStyle={mapContainerStyle} center={center} zoom={10}>
      <DirectionsServiceComponent locationsData={locationsData} />
    </GoogleMap>
  );
};

export default GoogleMapComponent;
